import { render, staticRenderFns } from "./DocumentTypesBrowser.vue?vue&type=template&id=3a8f43b7&scoped=true&"
import script from "./DocumentTypesBrowser.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentTypesBrowser.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentTypesBrowser.vue?vue&type=style&index=0&id=3a8f43b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f43b7",
  null
  
)

export default component.exports